import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { Spinner } from 'react-bootstrap';
import Screens from 'shared/screens';
import ImageBW from '../../components/ImageBoundsWrapper';
import SVideoAds from 'shared/screens/VideoAds';
import audio from 'shared/utils/audio';
import Utils from 'shared/utils/index';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';

var pad = require('underscore.string/pad');

export default class VideoAds extends Component {
  state = {
    startedPlaying: false,
    videoProgressPercent: 0,
    videoDuration: 0,
    videoPaused: false,
    showWarningPopUp: false,
  };

  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-video-ad',
    };
  }

  handleWarning = (value, error = false) => {
    if (error) {
      this.props.dismissModal();
      return;
    }
    audio.onClick();
    const { startedPlaying } = this.state;

    this.setState({ showWarningPopUp: value });

    if (startedPlaying) {
      this.setState({ videoPaused: value });
    }
  };

  handleVideoStarted = () => {
    const { showWarningPopUp } = this.state;

    this.setState({
      startedPlaying: true,
      videoPaused: showWarningPopUp,
    });
  };

  onDuration(duration) {
    if (this.state.videoDuration !== duration) {
      this.setState({ videoDuration: duration });
    }
  }

  onProgress(evt) {
    if (this.state.paused || evt.played === undefined || evt.played === null) {
      return;
    }

    this.setState({ videoProgressPercent: evt.played });
  }

  getTimeString(time) {
    return parseInt(time / 60) + ':' + pad(parseInt(time % 60), 2, '0');
  }

  render() {
    return (
      <SVideoAds
        navigation={this.props.navigation}
        render={props => {
          const { url, reward, completed, error, setCompleted, showModal, errorMessage } = props;
          const { startedPlaying } = this.state;
          const barWidth = this.state.videoProgressPercent >= 0.99 ? 1 : this.state.videoProgressPercent;
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                margin: 0,
                zIndex: 2,
              }}
            >
              <div
                onClick={() => this.handleWarning(true, error)}
                style={{
                  position: 'absolute',
                  top: '-1.75rem',
                  right: '-2rem',
                  padding: 0,
                  height: '4rem',
                  width: '4rem',
                  zIndex: 9,
                  cursor: 'pointer',
                  pointerEvents: 'auto',
                }}
              >
                <ImageBW
                  source={require(asset`CloseButton@3x.png`)}
                  ibw={require(asset`CloseButton.ibw`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  resizeMode="contain"
                />
              </div>
              <div className="videoAdsContainer">
                <div className="videoWrapper">
                  <div className="wrapper">
                    <ReactPlayer
                      url={url}
                      playing={!this.state.videoPaused}
                      onStart={this.handleVideoStarted}
                      onEnded={setCompleted}
                      onDuration={this.onDuration.bind(this)}
                      onProgress={this.onProgress.bind(this)}
                      allowFullScreen={false}
                      width="100%"
                      height="100%"
                      className="player"
                      style={this.state.videoProgressPercent !== 0 ? {} : { visibility: 'hidden' }}
                    />
                  </div>
                </div>
                <div className="progressArea">
                  <div className="timeArea">
                    <span className="videoTime">
                      {this.getTimeString(this.state.videoDuration * this.state.videoProgressPercent) +
                        ' / ' +
                        this.getTimeString(this.state.videoDuration)}
                    </span>
                  </div>
                  <div className="barArea">
                    <div className="backerContainer">
                      <div className="barBacker">
                        <div className="barFill" style={{ width: barWidth * 100 + '%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '11rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontWeight: '500',
                    fontSize: '3vmin',
                  }}
                >
                  {error === false && (
                    <div>
                      {(reward.amount === 0 || !startedPlaying || this.state.videoProgressPercent === 0) && (
                        <Spinner animation="border" style={{ position: 'absolute', top: '40%', left: '50%' }} />
                      )}
                    </div>
                  )}
                </div>
                {completed && showModal(Screens.Congrats)}
                {this.state.showWarningPopUp && (
                  <div className="warningOverlay">
                    <div className="warning">
                      <ImageBW
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '100%',
                        }}
                        source={require(asset`Dialog.png`)}
                        ibw={require(asset`Dialog.ibw`)}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            width: '100%',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                          }}
                        >
                          <span
                            style={{
                              textAlign: 'center',
                              display: 'flex',
                              justifyContent: 'center',
                              marginBottom: Utils.ieVersion() !== 0 ? 0 : 14,
                              fontWeight: 600,
                              fontSize: 25,
                            }}
                            className={`watchAndEarnGradientText warningHeader ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                            data-label={'Are you sure?'}
                          >
                            {getText(TEXT_KEY.ARE_YOU_SURE)}
                          </span>
                          <ImageBW
                            source={require(asset`Shop_VIP_Divider_Glows@3x.png`)}
                            ibw={require(asset`Shop_VIP_Divider_Glows.ibw`)}
                            manualAssetScale={3}
                            style={{ height: 40, width: '100%' }}
                            innerStyle={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-evenly',
                              alignItems: 'center',
                              paddingLeft: '1vmin',
                              paddingRight: '1vmin',
                            }}
                          ></ImageBW>
                          <div className={'warningMessage' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
                            {getText(TEXT_KEY.WILL_NOT_RECEIVE_COINS)}
                          </div>
                          <div className={'warningButton' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
                            <div className="closeButton">
                              <img
                                alt=""
                                src={require(asset`RoundedRect_Red@3x.png`)}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                              />
                              <span className="closeButtonLabel" onClick={() => this.props.dismissModal()}>
                                {getText(TEXT_KEY.CLOSE_VIDEO_MODAL)}
                              </span>
                            </div>
                            <div className="keepWatchingButton">
                              <img
                                alt=""
                                src={require(asset`RoundedRect_Pink@3x.png`)}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                              />
                              <span className="keepWatchingButtonLabel" onClick={() => this.handleWarning(false)}>
                                {getText(TEXT_KEY.KEEP_WATCHING)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </ImageBW>
                    </div>
                  </div>
                )}
                {error && (
                  <div className="warningOverlay">
                    <div className="warning">
                      <ImageBW
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '100%',
                        }}
                        source={require(asset`Dialog.png`)}
                        ibw={require(asset`Dialog.ibw`)}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            width: '100%',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                          }}
                        >
                          <span
                            style={{
                              textAlign: 'center',
                              display: 'flex',
                              justifyContent: 'center',
                              marginBottom: Utils.ieVersion() !== 0 ? 0 : 14,
                              fontWeight: 600,
                              fontSize: 25,
                            }}
                            className={`watchAndEarnGradientText warningHeader ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                            data-label={'ERROR'}
                          >
                            {getText(TEXT_KEY.VIDEO_ERROR)}
                          </span>
                          <div className={'warningMessage' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
                            {errorMessage || getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE)}
                          </div>
                          <div className={'warningButton' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
                            <div className="closeButton">
                              <img
                                alt=""
                                src={require(asset`RoundedRect_Red@3x.png`)}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                              />
                              <span className="closeButtonLabel" onClick={() => this.props.dismissModal()}>
                                {getText(TEXT_KEY.CLOSE_VIDEO_MODAL)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </ImageBW>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        }}
      />
    );
  }
}

VideoAds.hideCloseButton = true;

